import { Facebook } from 'blaze-ui/icons'
import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { callToAction } from './shared/callToAction'
import { productName } from './shared/productName'
import { promotion } from './shared/promotion'
import { seoWords } from './shared/seoWords'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { language } from './shared/language'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { TextChannels } from '../../../constants'

const meta = {
  icon: Facebook,
  type: ChannelType.FacebookAds,
  steps: ['Context', 'Generate Ads'],
  title: TextChannels[ChannelType.FacebookAds].name,
  submitLabel: 'Generate Ads',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183782/Home%20Card%20Previews/nw77ninn8uv6cnay8nds.png',
}

const fields = {
  topic: topic.meta({ label: 'What are the goals of your Facebook ad campaign?', generationType: meta.type }),
  product_name: productName.required(),
  seo_words: seoWords.meta({ label: 'What keywords should be included?' }),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  tone,
  language,
  include_images: includeImages.meta({
    description: 'An image will make your ads far more engaging and attention grabbing',
  }),
  promotion: promotion.meta({ collapsible: true }),
  callToAction: callToAction.meta({ collapsible: true }),
}

export const FacebookAdsSchema = object(fields).meta(meta) as FormSchema<ChannelType.FacebookAds>

const imagesStep = SelectImages.meta({ submitLabel: 'Generate Ads', type: ChannelType.FacebookAds }) as StepSchema

export const FacebookAdsMultiStepSchema: MultiStepSchema<ChannelType.FacebookAds> = {
  steps: [
    FacebookAdsSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    imagesStep,
  ],
  meta: {
    ...meta,
    type: ChannelType.FacebookAds,
    channel: ChannelType.FacebookAds,
  },
}
